<main>
 
  <div *ngIf="loading" class="container">
    <div class="row justify-center py-90">
      <div class="col-auto text-center">
        <div class="text-18 text-dark-1">Yükleniyor...</div>
      </div>
    </div>
  </div>

  <!-- Error State -->
  <div *ngIf="error && !loading" class="container">
    <div class="row justify-center py-90">
      <div class="col-auto text-center">
        <div class="text-18 text-red-1">{{ error }}</div>
        <button (click)="reloadBlog()" class="button -blue-1 mt-20">Tekrar Dene</button>
      </div>
    </div>
  </div>

  <!-- Blog Content -->
  <div *ngIf="!loading && !error && blog">
    <section class="d-flex items-center py-15 border-top-light">
      <div class="container">
        <div class="row y-gap-10 items-center justify-between">
          <div class="col-auto">
            <div class="row x-gap-10 y-gap-5 items-center text-14 text-light-1">
              <div class="col-auto">
                <a routerLink="/">Anasayfa</a>
              </div>
              <div class="col-auto">
                <div class="">></div>
              </div>
              <div class="col-auto">
                <a routerLink="/blog">Blog</a>
              </div>
              <div class="col-auto">
                <div class="">></div>
              </div>
              <div class="col-auto">
                <div class="text-dark-1">{{ blog.name }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="layout-pt-md">
      <div class="container">
        <div class="row y-gap-40 justify-center text-center">
          <div class="col-auto">
            <h1 class="text-30 fw-600">{{ blog.name }}</h1>
            <div class="text-15 text-light-1 mt-10" *ngIf="blog.publishedDate">
              {{ formatDate(blog.publishedDate) }}
            </div>
          </div>

          <div class="col-xl-10 col-lg-11 col-12">
            <img [src]="getMainImage()" [alt]="blog.name" class="w-100 rounded-8" style="max-height: 600px; object-fit: cover;">
          </div>
        </div>
      </div>
    </section>

    <section class="layout-pt-md layout-pb-md">
      <div class="container">
        <div class="row y-gap-30 justify-center">
          <div class="col-xl-8 col-lg-10">
            <div class="">
              <div class="text-15 mt-20" [innerHTML]="blog.content"></div>

              <!-- Additional Images -->
              <div class="row y-gap-30 pt-30" *ngIf="getAdditionalImages().length > 0">
                <div *ngFor="let image of getAdditionalImages()" class="col-md-6">
                  <img [src]="image" [alt]="blog.name" class="rounded-4 w-100">
                </div>
              </div>

              <div class="row y-gap-20 justify-between pt-30">
                <div class="col-auto">
                  <div class="d-flex items-center">
                    <div class="fw-500 mr-10">Paylaş</div>

                    <div class="d-flex items-center">
                      <a (click)="shareOnFacebook()" class="flex-center size-40 rounded-full cursor-pointer"><i class="icon-facebook text-14"></i></a>
                      <a (click)="shareOnTwitter()" class="flex-center size-40 rounded-full cursor-pointer"><i class="fab fa-x-twitter text-14"></i></a>
                      <a (click)="shareOnWhatsApp()" class="flex-center size-40 rounded-full cursor-pointer"><i class="fab fa-whatsapp text-14"></i></a>
                      <a (click)="shareOnInstagram()" class="flex-center size-40 rounded-full cursor-pointer"><i class="icon-instagram text-14"></i></a>
                    </div>
                  </div>
                </div>

                <div class="col-auto" *ngIf="blog.pusulaCategory">
                  <div class="row x-gap-10 y-gap-10">
                    <div class="col-auto">
                      <a href="#" class="button -blue-1 py-5 px-20 bg-blue-1-05 rounded-100 text-15 fw-500 text-blue-1">
                        {{ blog.pusulaCategory.name }}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="layout-pt-md layout-pb-lg" *ngIf="relatedBlogs.length > 0">
      <div class="container">
        <div class="row justify-center text-center">
          <div class="col-auto">
            <div class="sectionTitle -md">
              <h2 class="sectionTitle__title">İlgili İçerikler</h2>
              <p class="sectionTitle__text mt-5 sm:mt-0">Sizin için seçtiğimiz diğer blog yazıları</p>
            </div>
          </div>
        </div>

        <div class="row y-gap-30 pt-40">
          <div 
            *ngFor="let relatedBlog of relatedBlogs; let i = index" 
            class="col-lg-3 col-sm-6">
            <a [routerLink]="['/blog', relatedBlog.slug]" class="blogCard -type-2 d-block bg-white rounded-4 shadow-4">
              <div class="blogCard__image">
                <div class="ratio ratio-1:1 rounded-4">
                  <img class="img-ratio" [src]="getBlogImage(relatedBlog, i)" [alt]="relatedBlog.name">
                </div>
              </div>

              <div class="px-20 py-20">
                <h4 class="text-dark-1 text-16 lh-18 fw-500">{{ getTruncatedTitle(relatedBlog.name, 3) }}</h4>
                <div class="text-light-1 text-15 lh-14 mt-10" *ngIf="relatedBlog.publishedDate">
                  {{ formatDate(relatedBlog.publishedDate) }}
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  </div>

  <app-newsletter></app-newsletter>
</main>

